"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sessionIsUpcoming = exports.sessionIsTodayAndNotEnded = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _constants = require("./constants");
var _video = require("./video.utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var isPastJoinable = function isPastJoinable(endAt) {
  return (0, _momentTimezone.default)().isAfter((0, _momentTimezone.default)(endAt).add(_constants.GROUP_CALL_MEMBER_JOIN_GRACE_PERIOD, 'minutes'));
};

// Is upcoming or in progress
var sessionIsUpcoming = function sessionIsUpcoming(_ref) {
  var endAt = _ref.endAt,
    archived = _ref.archived;
  return !archived && (0, _momentTimezone.default)().isBefore((0, _momentTimezone.default)(endAt).add(_constants.GROUP_CALL_MEMBER_JOIN_GRACE_PERIOD, 'minutes')) && !isPastJoinable(endAt);
};
exports.sessionIsUpcoming = sessionIsUpcoming;
var sessionIsTodayAndNotEnded = function sessionIsTodayAndNotEnded(_ref2) {
  var startAt = _ref2.startAt,
    endAt = _ref2.endAt,
    archived = _ref2.archived;
  return !archived && (0, _video.isCallToday)(startAt) && !isPastJoinable(endAt);
};
exports.sessionIsTodayAndNotEnded = sessionIsTodayAndNotEnded;